import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_118: FaireProductEntity = {
  token: "catalog_prod_prod-118",
  type: "product",
  name: "Garland - White Mercury Glass Ornaments (Pc)",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
  priceDollars: 65.97,
  msrpDollars: 164.93,
  sku: "VI0118",
  caseSize: 4,
  material: "Metal",
  collectionToken: "col_vintage-holiday",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: false,
  stockLevel: 23,
  description: "Beautiful Vintage Holiday piece perfect for any home.",
  categoryTokens: ["catalog_cat_storage-organization"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
